import * as React from "react";

interface props {
  className?: string;
}
const ImageSvg = ({ className }: props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="38"
    height="38"
    className={className}
    fill="none"
    viewBox="0 0 38 38"
  >
    <path
      fill="#262626"
      d="M32.063 5.938H10.686a2.375 2.375 0 0 0-2.374 2.375v2.374H5.937a2.375 2.375 0 0 0-2.375 2.376v16.624a2.375 2.375 0 0 0 2.376 2.375h21.375a2.375 2.375 0 0 0 2.375-2.374v-2.375h2.375a2.375 2.375 0 0 0 2.374-2.375V8.313a2.375 2.375 0 0 0-2.374-2.376m-6.532 4.75a1.782 1.782 0 1 1 0 3.563 1.782 1.782 0 0 1 0-3.563m1.782 19H5.938V13.063h2.375v11.875a2.375 2.375 0 0 0 2.374 2.375h16.626zm4.75-4.75H10.686v-7.023l4.504-4.505a1.186 1.186 0 0 1 1.68 0l7.37 7.371 3.814-3.809a1.19 1.19 0 0 1 1.678 0l2.33 2.335z"
    ></path>
  </svg>
);

export default ImageSvg;
